<template lang="pug">
  #ItemsList
    appHeader
    router-view.content-body
    appSaFooter(v-if="profile && (profile.line_position === 'sa' || profile.line_position === 'sm')")
    appSicFooter(v-if="profile && profile.line_position === 'sic'")
</template>

<script>
  import { mapState } from 'vuex';

  import appHeader from '@/components/partials/AppHeader.vue';
import appSaFooter from '@/components/partials/AppSaFooter.vue';
import appSicFooter from '@/components/partials/AppSicFooter.vue';

export default {
  // 不管這邊打大小寫 顯示都會是以大寫形式為主
  name: 'ItemsListComponent',
  components: {
    appHeader,
    appSaFooter,
    appSicFooter
  },
  computed: {
    ...mapState({
      profile: (state) => state.sa_profile.data
    })
  },
  mounted() {
  }
};
</script>
